import { useState } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import Navbar from './Navbar';
import Sidebar from './Sidebar';


const titles = {
  '/': 'Dashboard',
  '/contracts': 'Generate Public Signing Link',
  '/templates': 'PDF Contract Templates',
  '/contacts': 'Contract Contacts',
  '/settings': 'Company Settings',
};

export default function AdminLayout({ theme, onToggleTheme, onLogout }) {
  const location = useLocation();
  const [sidebarOpen, setSidebarOpen] = useState(false);

  return (
    <div className={`admin-shell ${sidebarOpen ? 'sidebar-active' : ''}`}>
      <Sidebar isOpen={sidebarOpen} onClose={() => setSidebarOpen(false)} />
      {sidebarOpen && <div className="sidebar-overlay" onClick={() => setSidebarOpen(false)} />}
      <main>
        <Navbar
          title={titles[location.pathname] || 'Contracts'}
          theme={theme}
          onToggleTheme={onToggleTheme}
          onLogout={onLogout}
          onToggleSidebar={() => setSidebarOpen(!sidebarOpen)}
        />
        <Outlet />
      </main>
    </div>
  );
}

